import { hashToHex } from 'js/lib/hash';

export const getChatSessionKey = (isAuthenticated: boolean, productSlug: string) =>
  isAuthenticated ? `logged-in-${productSlug}` : `logged-out-${productSlug}`;

// A React remount key only (not CoachChat's chatSessionKey), so its session-restore effect
// re-runs on product/user change; the platform handles session storage scoping itself.
export const getCoachChatRemountKey = (isAuthenticated: boolean, userId: number | undefined, productSlug: string) =>
  isAuthenticated && userId ? `logged-in-${hashToHex(String(userId))}-${productSlug}` : `logged-out-${productSlug}`;
